import React from 'react'
import { timeSince, make2Places } from '../util/time_utils'

import { updateElectronDuration } from '../util/electron_ipc'

class RunningTime extends React.Component {
    constructor(props) {
        super(props)

        this.updateDisplay = this.updateDisplay.bind(this)

        this.interval = null

        this.state = {
            display: timeSince(this.props.startAt),
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.updateDisplay()
        }, 1000)
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.startAt !== this.props.startAt) {
            this.updateDisplay()
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval)
        this.interval = null
    }

    updateDisplay() {
        this.setState({
            display: timeSince(this.props.startAt),
        })
        this.updateDuration(this.props.startAt)
    }

    updateDuration(startAt) {
        let duration = new Date().getTime() - startAt
        let timeSince = make2Places(duration / 60 / 60 / 1000)

        updateElectronDuration(timeSince, true)
    }

    render() {
        return (
            <span className="running-time">{this.state.display}</span>
        )
    }
}

export default RunningTime


// WEBPACK FOOTER //
// ./src/components/running_time.jsx